import { useQuery } from '@tanstack/react-query'
import { sortBySequenceNumber } from 'shared/lib/common-util'
import { QueryKeys } from '../../../key-registry'
import { fromDocumentResponse } from '../../document/models/responseToModel'
import { Document } from '../../document/models/types'
import { fetchConsignmentItemDocumentsV3 } from './http'

export async function fetchConsignmentItemDocuments(id: number, opts?: { signal?: AbortSignal }): Promise<Document[]> {
  const responses = await fetchConsignmentItemDocumentsV3({ consignmentItemId: id }, opts)

  return responses.map((response, index) => fromDocumentResponse(response, index)).sort(sortBySequenceNumber)
}

export function useFetchConsignmentItemDocuments(consignmentItemId: number | null) {
  return useQuery({
    queryKey: QueryKeys.consignmentItemDocument.byConsignmentItemId(consignmentItemId),
    queryFn: ({ signal }) => fetchConsignmentItemDocuments(consignmentItemId as number, { signal }),
    enabled: !!consignmentItemId,
  })
}
